/**
 * API Configuration - Dynamic Backend URL Detection
 * 
 * This automatically detects the correct backend URL based on the current hostname.
 * Works for both preview and deployed environments without needing to change .env files.
 */

const getBackendURL = () => {
  // If REACT_APP_BACKEND_URL is set and we're in the same domain, use it
  const envBackendURL = process.env.REACT_APP_BACKEND_URL;
  
  // Get current hostname
  const currentHostname = window.location.hostname;
  
  // If we're running on localhost (development), use the env variable
  if (currentHostname === 'localhost' || currentHostname === '127.0.0.1') {
    return envBackendURL || 'http://localhost:8001';
  }
  
  // For deployed/preview environments, check if env URL matches current domain
  if (envBackendURL) {
    try {
      const envURL = new URL(envBackendURL);
      const currentDomain = currentHostname;
      
      // If the env URL's hostname matches our current hostname, use it
      if (envURL.hostname === currentDomain) {
        return envBackendURL;
      }
    } catch (e) {
      console.warn('Invalid REACT_APP_BACKEND_URL:', envBackendURL);
    }
  }
  
  // Otherwise, construct backend URL from current hostname
  // This handles the case where frontend and backend are on the same domain
  const protocol = window.location.protocol;
  const backendURL = `${protocol}//${currentHostname}`;
  
  console.log(`Dynamic Backend URL: ${backendURL}`);
  return backendURL;
};

export const BACKEND_URL = getBackendURL();
export const API = `${BACKEND_URL}/api`;

// Log the configuration for debugging
console.log('API Configuration:', {
  BACKEND_URL,
  API,
  currentHostname: window.location.hostname,
  envBackendURL: process.env.REACT_APP_BACKEND_URL
});
